<template>
    <!-- 产品详情页 -->
	<div class="content">
		<Header></Header>
		<product-banner :productId="productId"></product-banner>
        <!-- 服务模块 -->
		<div class="main-content">
            <!-- 服务标题 -->
            <div class="headline" v-if="serviceTitle">
	        	<div class="title">{{serviceTitle.name}}</div>
	        	<div class="description">
	        		{{serviceTitle.value}}
	        	</div>
	        	<div class="hr"></div>
	        </div>
            <!-- 服务产品列表 -->
			<div class="container">
				<div class="item" v-for="(item) in serviceProductList" :key="item.id">
					<div class="icon">
                        <img :src="item.image">	
					</div>
					<div class="text">
						<div class="title">{{item.name}}</div>
						<div class="description">{{item.value}}</div>
					</div>
				</div>
			</div>
		</div>
        <!-- pc -->
		<div class="pc">
			<div class="image">
				<!-- <img src="" alt=""> -->
			</div> 
			<div class="info">
				<div class="title">
					PC端解决方案
				</div>
				<ul>
					<li>最新活动专区，您可了解索道云当前所有优惠活动</li>
					<li>最新活动专区，您可了解索道云当前所有优惠活动</li>
					<li>最新活动专区，您可了解索道云当前所有优惠活动</li>
				</ul>
			</div> 
		</div>
        <!-- app -->
		<div class="app">
			<div class="info">
				<div class="title">
					APP端解决方案
				</div>
				<ul>
					<li>最新活动专区，您可了解索道云当前所有优惠活动</li>
					<li>最新活动专区，您可了解索道云当前所有优惠活动</li>
					<li>最新活动专区，您可了解索道云当前所有优惠活动</li>
				</ul>
			</div> 
			<div class="image">
                <img src="../../../assets/channel/app.png" alt="">
			</div> 
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
    import { queryAttributeValueByProductId } from '@/api/channel/product.js'
    import Header from '../../../components/common/header.vue'
    import ProductBanner from '../../../components/channel/productBanner.vue'
    import Footer from '../../../components/common/footer.vue'
    export default {
        components: {
            Header,
            ProductBanner,
            Footer
        },
        data() {
            return {
                id: 0,
                serviceTitle: {},
                serviceProductList: [],
            }
        },
        props: ['productId'],
        watch: {
            productId: function(val) {
                this.productId = val;
                this.getData();
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                if (this.$route.query.id) {
                    this.id = this.$route.query.id;
                } else {
                    this.id = this.productId;
                }
                //查询服务模块
                let id = this.id;
                queryAttributeValueByProductId(id).then(res => {
                    this.serviceTitle = res.data.list[0];//服务标题
                    let serviceProductList = res.data.list.filter((val, index) => {//服务产品列表
                        return index != 0;
                    })
                    this.serviceProductList = serviceProductList;
                })
            },
        },
    }
</script>

<style lang="scss" scoped="scoped">
    .content {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        .main-content {
            min-width: 1330px;
            padding: 0 15%;
            margin-top: 75px;
            .headline {
                display: flex;
                flex-direction: column;
                align-items: center;
                .title {
                    color: #507df1;
                    font-size: 36px;
                }
                .description {
                    margin: 25px 0;
                    color: #7f7f7f;
                    font-size: 16px;
                }
                .hr {
                    width: 32px;
                    height: 4px;
                    background-color: #507df1;
                }
            }
            .container {
                margin: 50px 0;
                display: flex;
                justify-content: space-between;
                flex-flow: row wrap;
                align-items: center;
                .item {
                    width: 400px;
                    height: 120px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 30px;
                    .icon {
                        img {
                            width: 100px;
                            height: 100px;
                        }
                    }
                    .text {
                        margin: 0 10px;
                        .title {
                            font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
                            font-weight: 700;
                            font-style: normal;
                            font-size: 16px;
                            color: #515151;
                        }
                        .description {
                            font-size: 10px;
                            color: #7F7F7F;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
        .pc {
            width: 1920px;
            height: 618px;
            background: url('../../../assets/channel/pc_background.png');
            .info {
                height: 618px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                float: right;
                margin-right: 300px;
                color: #ffffff;
                .title {
                    font-size: 36px;
                    margin: 20px 0 20px 40px;
                }
                li {
                    font-family: '思源黑体 CN';
                    font-weight: 400;
                    font-style: normal;
                    font-size: 16px;
                    color: #C3C3C3;
                    margin: 20px 0;
                }
            }
        }
        .app {
            width: 1920px;
            height: 700px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .info {
                height: 618px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 300px;
                .title {
                    color: #507df1;
                    font-size: 36px;
                    margin: 20px 0 20px 40px;
                }
                li {
                    font-family: '思源黑体 CN';
                    font-weight: 400;
                    font-style: normal;
                    font-size: 16px;
                    color: black;
                    margin: 20px 0;
                }
            }
            .image {
                margin-right: 300px;
                img {
                    height: 618px;
                }
            }
        }
    }
</style>